module.exports = __webpack_public_path__ + "img/P.fe410b8.jpg";